import React from 'react'
import DataLoader from '../../../Utils/DataLoader';
import BannerSec from '../restaurent/bannerSec/BannerSec';
import { Fragment } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiData } from '../../../actions';
import { useEffect } from 'react';
import { UsePlaceAuth } from '../../../AppContext/AppContext';
import { Helmet } from 'react-helmet';
import { _Deals_ } from '../../../Redux/Action/Action';
import { useDispatch, useSelector } from 'react-redux';

const HotelsDeals = () => {
  const [dealsData, setDealsData] = useState("");
  const [loader, setLoader] = useState(false)
  const { dealsTabActive, setDealsTabActive } = UsePlaceAuth()
  const dispatch = useDispatch();
  const place = useSelector(state => state.place)
  const { active, setActive } = UsePlaceAuth()
  const GetDeals = async () => {
    let payload = {
      city: place,
      keyword: "Hotels",
      limit: 12
    };
    setLoader(true)
    let apiRes = await apiData.getRandomDeals(payload);
    if (apiRes?.status >= 200 && apiRes?.status <= 399) {
      setDealsData(
        apiRes?.data?.data[0].content.split('"')[1]
      );

      setLoader(false);
    }
    if (apiRes?.status >= 400 && apiRes?.status <= 500) {
      console.log("error");
    }
  };

  useEffect(() => {
    dispatch(_Deals_())
    let script = document.createElement('script');
    setLoader(true)
    script.id = "stay"
    script.src = dealsData
    document.getElementById("hotel_stay").appendChild(script);
    setLoader(false)
    setDealsTabActive("hotels")
    GetDeals();
  }, [place, dealsData]);

  return (
    <div>
      <Fragment>
        <Helmet>
          <title>Find Exclusive Deals for your destination - MySittiVacations</title>
          <meta name="description" content="Looking for the best travel deals? Find exclusive offers for your destination with our expert guide. Discover amazing discounts on flights, hotels, and activities to help you save big on your next trip."></meta>
        </Helmet>
        <BannerSec />
        <div
          className="itemBox"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        >
          <div className="offer-section">
            <div className="container">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                  <div className="header-sec">
                    <h2>Offers for you</h2>
                    <ul>
                      <li className={dealsTabActive === "All" ? "activeMenu" : ""}>
                        <Link to={`/deals/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("All")} >
                          <img src={
                            dealsTabActive === "All"
                              ? "/images/allinclusicActive-icon.png"
                              : "/images/allinclusic-icon.png"
                          } alt="allinclusic-icon" />
                          All Inclusive
                        </Link>
                      </li>


                      <li className={dealsTabActive === "flights" ? "activeMenu" : ""}>
                        <Link to={`/deals/flights/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("flights")} >
                          <img src={
                            dealsTabActive === "flights"
                              ? "/images/flightActive-icon.png"
                              : "/images/flight-icon.png"
                          } alt="flight-icon" />
                          Flights
                        </Link>
                      </li>
                      <li className={dealsTabActive === "hotels" ? "activeMenu" : ""}>
                        <Link to={`/deals/hotels/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("hotels")} >

                          <img src={
                            dealsTabActive === "hotels"
                              ? "/images/hotelActive-icon.png"
                              : "/images/hotel-icon.png"
                          } alt="hotel-icon" />
                          Hotels
                        </Link>
                      </li>
                      <li className={dealsTabActive === "vacations" ? "activeMenu" : ""}>
                        <Link to={`/deals/vacations/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("vacations")}>

                          <img src={
                            dealsTabActive === "vacations"
                              ? "/images/vacationActive-icon.png"
                              : "/images/vacation-icon.png"
                          } alt="vacation-icon" />
                          Vacations
                        </Link>
                      </li>
                      <li className={dealsTabActive === "tours" ? "activeMenu" : ""}>
                        <Link to={`/deals/tours/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("tours")}>

                          <img src={
                            dealsTabActive === "tours"
                              ? "/images/tourActive-icon.png"
                              : "/images/tour-icon.png"
                          } alt="tour-icon" />
                          Tours
                        </Link>
                      </li>
                      <li className={dealsTabActive === "cruises" ? "activeMenu" : ""}>
                        <Link to={`/deals/cruises/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("cruises")}>

                          <img src={
                            dealsTabActive === "cruises"
                              ? "/images/curizeActive-icon.png"
                              : "/images/curize-icon.png"
                          } alt="curize-icon" />
                          Cruises
                        </Link>
                      </li>
                      <li className={dealsTabActive === "adventures" ? "activeMenu" : ""}>
                        <Link to={`/deals/adventures/${place}`} className="nav-link dealsIconss" onClick={() => setDealsTabActive("adventures")}>

                          <img src={
                            dealsTabActive === "adventures"
                              ? "/images/advantureActive-icon.png"
                              : "/images/advanture-icon.png"
                          } alt="advanture-icon" />
                          Adventures
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {
                  !loader ? "" : <div style={{ marginTop: "60vh" }}>
                    <DataLoader />
                  </div>
                }
                <div data-aos="zoom-in-right" className="testimonial-section products client-sec comedy family-sec">
                  <div id="hotel_stay">
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </Fragment>
    </div>
  )
}

export default HotelsDeals